import { useState } from "react";

const NAV_LINKS = [
  { label: "今日热榜", href: "#hot" },
  { label: "深扒精选", href: "#featured" },
  { label: "专题合集", href: "#collections" },
  { label: "栏目分类", href: "#categories" },
  { label: "深度解读", href: "#deep" },
  { label: "常见问题", href: "#faq" },
  { label: "关于本站", href: "#about" },
];

export default function Navbar({ scrolled, onOpenSearch }: { scrolled: boolean; onOpenSearch: () => void }) {
  const [open, setOpen] = useState(false);
  const solid = scrolled;
  const light = !solid; // transparent over dark hero => light text

  return (
    <header
      className={
        "fixed inset-x-0 top-0 z-50 transition-all duration-300 " +
        (solid ? "bg-background-50/90 backdrop-blur-md border-b border-background-200" : "bg-transparent")
      }
    >
      <nav className="container-page flex h-16 md:h-[76px] items-center justify-between gap-4">
        {/* brand */}
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 md:h-10 md:w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg md:text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={
                "font-heading text-lg md:text-xl font-bold tracking-tight " +
                (light ? "text-background-50" : "text-foreground-950")
              }
            >
              每日黑料
            </span>
            <span className={"text-[10px] tracking-[0.3em] " + (light ? "text-background-100/70" : "text-foreground-500")}>
              HOT PICS DAILY
            </span>
          </span>
        </a>

        {/* desktop links */}
        <ul className="hidden lg:flex items-center gap-1">
          {NAV_LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                className={
                  "whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors " +
                  (light
                    ? "text-background-100 hover:bg-background-50/10 hover:text-white"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950")
                }
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        {/* actions */}
        <div className="flex items-center gap-2 md:gap-3">
          <button
            onClick={onOpenSearch}
            aria-label="站内搜索"
            className={
              "flex items-center gap-2 whitespace-nowrap rounded-full px-3 py-2 text-sm transition-colors md:px-4 " +
              (light
                ? "bg-background-50/10 text-background-50 ring-1 ring-background-50/25 hover:bg-background-50/20"
                : "bg-background-100 text-foreground-800 ring-1 ring-background-300/60 hover:bg-background-200")
            }
          >
            <i className="ri-search-line"></i>
            <span className="hidden md:inline">搜索热点</span>
          </button>
          <a
            href="#contact"
            className="hidden md:inline-flex whitespace-nowrap items-center gap-2 rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            我要反馈
            <i className="ri-arrow-right-up-line"></i>
          </a>
          {/* hamburger */}
          <button
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className={
              "flex h-10 w-10 items-center justify-center rounded-md lg:hidden transition-colors " +
              (light ? "text-background-50 hover:bg-background-50/10" : "text-foreground-800 hover:bg-background-100")
            }
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
          </button>
        </div>
      </nav>

      {/* mobile menu */}
      {open && (
        <div className="lg:hidden border-t border-background-200 bg-background-50/95 backdrop-blur-md">
          <ul className="container-page py-3">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between rounded-lg px-3 py-3 text-[15px] font-medium text-foreground-800 hover:bg-background-100"
                >
                  {l.label}
                  <i className="ri-arrow-right-line text-foreground-400"></i>
                </a>
              </li>
            ))}
            <li className="mt-2 px-1">
              <a
                href="#contact"
                onClick={() => setOpen(false)}
                className="flex items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50 hover:bg-primary-600"
              >
                <i className="ri-chat-3-line"></i> 我要反馈
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}